<div echarts [options]="option" class="funnel-chart"></div>